module.exports = __webpack_public_path__ + "img/congrat.7a515954.png";